module.exports = __webpack_public_path__ + "static/uni_grambling-c348ff1bea8c52ce45f6d5391d924ce5.png";